import { useEffect, useRef } from 'react';
import { useReactDndConstructs } from '../../../dnd/ReactDndContext';
import { getDndStyleTokens } from '../../../style/reactDnd/DndStyleTokens';
import { useDesignTokens } from '../../../theme';
import { DraggableTokenProps } from '../../TokenInput';
import cx from 'classnames';
import cn from './TokenDnd.css.json';
import './TokenDnd.css';

export const useDraggableToken = (props: DraggableTokenProps) => {
  const dragRef = useRef<HTMLDivElement>(null);
  const { useDrag, getEmptyImage } = useReactDndConstructs();
  const dt = useDesignTokens();
  const dndTokens = getDndStyleTokens(dt);

  const [{ isDragging }, drag, preview] = useDrag({
    type: props.type,
    item: props,
    canDrag: props.allowDrag,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview, getEmptyImage]);

  drag(dragRef);

  return {
    ref: dragRef,
    style: dndTokens,
    className: cx(props.allowDrag && cn.draggable, isDragging && cn.draggedItem),
  };
};
